import { render } from "./NavigationFooter.vue?vue&type=template&id=220f0cf6&scoped=true&ts=true"
import script from "./NavigationFooter.vue?vue&type=script&lang=ts"
export * from "./NavigationFooter.vue?vue&type=script&lang=ts"

import "./NavigationFooter.vue?vue&type=style&index=0&id=220f0cf6&scoped=true&lang=css"

import exportComponent from "/home/runner/work/qti-player/qti-player/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-220f0cf6"]])

export default __exports__